import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiStar, FiUser } = FiIcons;

const Testimonials = () => {
  const testimonials = [
    {
      name: 'คุณสุภาพร',
      text: 'รู้สึกสงบและมีสมาธิมากขึ้นหลังทำพิธี การได้เรียนรู้ขั้นตอนที่ถูกต้องทำให้เข้าใจหลักการมากขึ้น',
      rating: 5
    },
    {
      name: 'คุณวิชัย',
      text: 'ประทับใจในความละเอียดของพิธีกรรม นักพรตอธิบายความหมายในแต่ละขั้นตอนได้ชัดเจน',
      rating: 5
    },
    {
      name: 'คุณพิมพ์ชนก',
      text: 'บรรยากาศในกลุ่มดีมาก ได้แลกเปลี่ยนประสบการณ์กับผู้ที่สนใจศาสตร์เดียวกัน',
      rating: 5
    }
  ];

  return (
    <section className="py-10 md:py-16 bg-gradient-to-br from-gray-50 to-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-8"
        >
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            ประสบการณ์และความรู้สึก
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            ความรู้สึกจากผู้เข้าร่วมทริปที่ผ่านมา
          </p>
        </motion.div>

        {/* Featured Image */}
        <motion.div 
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="mb-8"
        >
          <div className="relative overflow-hidden rounded-2xl shadow-xl max-w-4xl mx-auto">
            <img
              src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1752685398663-blob"
              alt="พิธีเชื่อมพลังเทพมังกร"
              className="w-full h-[300px] object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
              <h3 className="text-2xl font-bold">ประสบการณ์ที่น่าจดจำ</h3>
              <p className="text-lg opacity-90">ผู้เข้าร่วมกิจกรรมในทริปที่ผ่านมา</p>
            </div>
          </div>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="bg-white rounded-2xl shadow-lg p-8 hover:shadow-xl transition-shadow duration-300"
            >
              {/* Stars */}
              <div className="flex justify-center space-x-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <SafeIcon key={i} icon={FiStar} className="w-5 h-5 text-yellow-400 fill-current" />
                ))}
              </div>

              {/* Quote */}
              <blockquote className="text-gray-700 text-center leading-relaxed mb-6">
                "{testimonial.text}"
              </blockquote>

              {/* Author */}
              <div className="flex items-center justify-center space-x-3">
                <div className="w-10 h-10 bg-gradient-to-br from-red-500 to-red-600 rounded-full flex items-center justify-center">
                  <SafeIcon icon={FiUser} className="w-5 h-5 text-white" />
                </div>
                <p className="font-semibold text-gray-900">
                  {testimonial.name}
                </p>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          viewport={{ once: true }}
          className="mt-8 text-center"
        >
          <div className="bg-gradient-to-r from-red-50 to-amber-50 border border-red-200 rounded-xl p-8 max-w-4xl mx-auto">
            <p className="text-lg text-gray-700 font-medium">
              ทุกความรู้สึกและประสบการณ์ล้วนเป็นส่วนหนึ่งของการเรียนรู้
              <br />
              <span className="text-red-700 font-semibold">
                ที่สำคัญคือการได้เข้าใจหลักการและปฏิบัติอย่างถูกต้อง
              </span>
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Testimonials;